export const checkElementName = (url: string): string => {
  switch (true) {
    case url.includes('brands'):
      return 'toBrands';
    case url.includes('catalogue'):
      return 'toPLP';
    case url.includes('search'):
      return 'toSRP';
    default:
      return 'unknown';
  }
};
